import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      text: 'SSL Encrypted',
      description: '256-bit encryption'
    },
    {
      icon: 'Lock',
      text: 'Secure Login',
      description: 'Multi-factor authentication'
    },
    {
      icon: 'CheckCircle',
      text: 'SOC 2 Compliant',
      description: 'Enterprise security standards'
    }
  ];

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-center space-x-2 text-center sm:text-left">
            <div className="flex-shrink-0">
              <Icon 
                name={feature?.icon} 
                size={16} 
                className="text-success" 
              />
            </div>
            <div className="min-w-0">
              <p className="text-xs font-medium text-foreground">
                {feature?.text}
              </p>
              <p className="text-xs text-muted-foreground truncate">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityBadges;